var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('van-nav-bar', {
    staticClass: "nav_bar_new",
    scopedSlots: _vm._u([{
      key: "left",
      fn: function () {
        return [_c('van-icon', {
          attrs: {
            "color": "white",
            "name": "arrow-left",
            "size": "21"
          },
          on: {
            "click": function ($event) {
              return _vm.handleBack();
            }
          }
        })];
      },
      proxy: true
    }, {
      key: "right",
      fn: function () {
        return [_c('div', [_vm._t("right_icon")], 2)];
      },
      proxy: true
    }, {
      key: "title",
      fn: function () {
        return [_c('span', {
          staticClass: "navbar_title"
        }, [_vm._v(" " + _vm._s(_vm.title) + " ")])];
      },
      proxy: true
    }], null, true)
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };